export default __webpack_public_path__ + "static/media/park8.e3808b4b.jpg";